import React, {Component} from 'react';
import { connect } from 'react-redux';
import { logOutAction } from './../../redux/modules/users'
import { Row , Col} from 'reactstrap'


class SidebarFooter extends Component {



  render() {
    
    return (
      <Row>
        <Col md="12" sm="12">
      <div className="sidebar-footer" onClick = {this.props.onLogout} style={{'cursor' : "pointer"}}>
        <button  className = "logoutButton" >
           Logout
        </button>
      </div>
        </Col>
      </Row>
    )
  }
}

const mapDispatchToProps = (dispatch) =>{
  return {
    onLogout : () => {dispatch(logOutAction())}
  }
}

const mapStateToProps = (state) =>{
  return {
    state : () => state
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(SidebarFooter)



// WEBPACK FOOTER //
// ./src/components/SidebarFooter/SidebarFooter.js